import React, { useContext } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import Lottie from 'react-lottie-player';
import { useNavigate, useParams } from "react-router-dom";
import { AppContext } from '../../../context/app-context';
import { openGoalSetWeb } from '../../../helper/mobile';
import activeJson from './active-code-success.json';

const InfoScreen = () => {

    let navigate = useNavigate();
    let { active } = useParams();
    const [state, dispatch] = useContext(AppContext);
    console.log('state', state);
    const onClickPlanHandler = () => {
        const user = state.user;
                
        if(user.isGoalSet === 'true'){
           
                navigate(`/dietPlan/healthConditions`);
                dispatch({
                    type: "ACTIVATE_PLAN",
                    payload: { activatePlan:true },
                  });
        }else {
            openGoalSetWeb()
        }
    }
    
    return (
        <Container>
            <Row className='min-vh-90 justify-content-center align-items-center text-center info-screen'>
                <Col>
                    { active === 'true' && <Lottie
                        loop={false}
                        animationData={activeJson}
                        play
                        style={{ height: 200 }}
                        className="success-lottie"
                    /> }
                    { active === 'true' && <h3 className='mb-0'>You’re in!</h3> }
                    <h3>{state?.infoScreen?.title}</h3>
                    <p>
                        {state?.infoScreen?.description}
                    </p>
                </Col>
            </Row>
            <div className="empty-space-82"></div>
            <div className="fix-div-button">
                <Button className="risk-btn" onClick={onClickPlanHandler}>{state?.infoScreen?.btnText}</Button>
            </div>
        </Container>
    );
};

export default InfoScreen;